<template>
  <div>
    <el-card body-style="padding: 0">
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="1">
          <el-col :span="5">
            <el-form-item label="所属商家" prop="userName">
              <el-input v-model="queryForm.userName" placeholder="请输入商家"/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="店铺名称" prop="shopName">
              <el-input v-model="queryForm.shopName" placeholder="请输入店铺名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="掌柜名" prop="shopUsername">
              <el-input v-model="queryForm.shopUsername" placeholder="请输入掌柜名"/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="店铺组(商家)" prop="shopGroup">
              <el-input v-model="queryForm.shopGroup" placeholder="请输入店铺组"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="2">
          <el-col :span="5">
            <el-form-item label="店铺组(系统)" prop="systemGroup">
              <el-input v-model="queryForm.systemGroup" placeholder="请输入店铺组"/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="平台" prop="shopTypeId">
              <el-select v-model="queryForm.shopTypeId" clearable placeholder="请选择">
                <el-option
                    v-for="item in allShopTypes"
                    :key="item.value"
                    :label="item.shopType"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="审核状态" prop="status">
            <el-select v-model="queryForm.status" clearable placeholder="请选择">
              <el-option
                  v-for="item in statusOptions"
                  :key="item.statusCode"
                  :label="item.statusName"
                  :value="item.statusName"
              >
              </el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="8" :offset="1">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询</el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <el-button type="success" size="small" style="margin: 0 0 10px 20px"
                 @click="reviewBatchPass">批量通过</el-button>
      <el-table :data="tableData"
                ref="table"
                border default-expand-all stripe
                :header-cell-style="{'text-align':'center'}"
                :max-height="tableHeight"
                style="width: 100%;margin-bottom: 20px;"
                :cell-style="{'text-align':'center'}"
                @selection-change="handleSelectionChange">
        <el-table-column label="全选" width="50" type="selection"/>
        <el-table-column prop="id" label="编号" width="120">
          <!--<template slot-scope="scope">
            <span>{{getStrEndWithNumbers(scope.row.id)}}</span>
          </template>-->
        </el-table-column>
        <el-table-column prop="userName" label="所属商家" />
        <el-table-column prop="shopName" label="店铺名称">
          <template slot-scope="scope">
            <a :href="scope.row.shopUrl" target="_blank"><span style="color: #409EFF">{{scope.row.shopName}}</span></a>
          </template>
        </el-table-column>
        <el-table-column prop="shopUsername" label="掌柜名" />
        <el-table-column prop="shopType" label="店铺类型" />
        <el-table-column prop="reviewStatus" label="店铺状态" />
        <el-table-column prop="shopGroup" width="120" label="店铺组(商家)" />
        <el-table-column prop="rebuyDays" width="120" label="复购天数(商家)" />
        <el-table-column prop="systemGroup" width="120" label="店铺组(系统)" />
        <el-table-column prop="sysRebuyDays" width="120" label="复购天数(系统)" />
        <el-table-column prop="createTime" label="添加时间" />
        <el-table-column prop="remarks" label="备注" />
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="success" plain
                       @click="handleShopEdit(scope.$index, scope.row, '设置商家店铺')">
              设置
            </el-button>
            <el-button size="mini" type="primary" plain v-if="scope.row.reviewStatus == '未审核'
                                                               || scope.row.reviewStatus == '审核中'"
                       @click="handleReviewEdit(scope.$index, scope.row,'店铺信息审核')">
              审核
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form ref="dialogForm" :model="dialogForm" label-width="230px">
        <el-form-item label="店铺名称">
          <el-input  v-model="dialogForm.shopName" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="掌柜名">
          <el-input v-model="dialogForm.shopUsername" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="店铺链接">
          <el-input v-model="dialogForm.shopUrl" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="店铺组名(系统)">
          <el-input v-model="dialogForm.shopGroup" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="复购天数(系统)">
          <el-input v-model="dialogForm.rebuyDays" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="每日商返订单数限制">
          <el-input v-model="dialogForm.orderReturnNumLimitDay" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="每日商返订单金额限制">
          <el-input v-model="dialogForm.orderReturnMoneyLimitDay" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="商家返款截点金额">
          <el-input v-model="dialogForm.moneyReturnHoldLimit" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="任务操作页店铺名称提示显示位置">
          <el-checkbox-group v-model="shopNameShowPositionAry">
            <el-checkbox label="1"></el-checkbox>
            <el-checkbox label="2" checked></el-checkbox>
            <el-checkbox label="3" checked></el-checkbox>
            <el-checkbox label="4" checked></el-checkbox>
            <el-checkbox label="5"></el-checkbox>
            <el-checkbox label="6"></el-checkbox>
            <el-checkbox label="7" ></el-checkbox>
            <el-checkbox label="8" ></el-checkbox>
            <el-checkbox label="9" ></el-checkbox>
            <el-checkbox label="10"></el-checkbox>
            <el-checkbox label="11"></el-checkbox>
            <el-checkbox label="12" ></el-checkbox>
            <el-checkbox label="13" ></el-checkbox>
            <el-checkbox label="14" ></el-checkbox>
            <el-checkbox label="15"></el-checkbox>
            <el-checkbox label="最后一位"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="试客复购判断">
          <el-radio-group v-model="dialogForm.customerRebuyVerify">
            <el-radio label="202112200001">默认设置</el-radio>
            <el-radio label="202112200002">按平台账号</el-radio>
            <el-radio label="202112200003">按试客账号</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogForm()" size="mini" type="primary">提交</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialogReviewTitle" :visible.sync="dialogReviewFormVisible">
      <el-form ref="dialogReviewForm" :model="dialogReviewForm" label-width="220px">
        <!--<el-form-item label="审核状态">
          <span style="color: red;">{{dialogReviewForm.reviewStatus}}</span>
        </el-form-item>
        <el-form-item label="添加时间">
          <span>{{dialogReviewForm.createTime}}</span>
        </el-form-item>
        <el-form-item label="所属平台">
          <span>{{dialogReviewForm.shopType}}</span>
        </el-form-item>
        <el-form-item label="店铺名称">
          <a :href="dialogReviewForm.shopUrl" target="_blank"><span>{{dialogReviewForm.shopName}}</span></a>
        </el-form-item>
        <el-form-item label="店铺昵称">
          <span>{{dialogReviewForm.shopUsername}}</span>
        </el-form-item>
        <el-form-item>
          <template #label>
            <span style="color: red;">上次审核说明</span>
          </template>
          <span style="color: red;" v-show="false">你这个是拼多多的 你要选择下拼多多， 你这个选项是淘宝的</span>
        </el-form-item>
        <el-form-item label="审核操作">
          <el-select v-model="dialogReviewForm.status" clearable style="width: 30%" size="mini">
            <el-option
                v-for="item in statusOptions"
                :key="item.statusCode"
                :label="item.statusName"
                :value="item.statusCode"
            >
            </el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="审核原因">
          <el-input v-model="dialogReviewForm.because" style="width: 50%;" size="mini"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitStatus(2)" size="mini" type="primary">审核通过</el-button>
        <el-button @click="submitStatus(3)" size="mini" type="primary">审核不通过</el-button>
        <el-button @click="handleReviewCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {
  getShopSetting,
  getShopsVo,
  updateBatchShopStatus,
  updateShopSetting,
  updateShopStatus
} from "../../api/b2cbusiness/storelist";
import {getStrEndWithNumbers, isStrEmpty} from "../../lib/utils";
import {getAllShopType} from "../../api/b2cbusiness/b2c_shoptype";
import MinxinScroll from "@/components/MinxinScroll";
export default {
  name: "shoplist",
  mixins:[MixinCUD, MinxinScroll],
  data(){
    return {
      tableData:[],
      queryFormRefName:"queryForm",
      allShopTypes:[],
      queryForm:{
        userName: '',
        shopName: '',
        shopUsername: '',
        shopGroup: '',
        shopTypeId: null,
        status: ''
      },
      shopNameShowPositionAry:[],
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm:{
      },
      dialogReviewFormVisible: false,
      dialogReviewTitle: "",
      dialogReviewRefName: "dialogReviewForm",
      dialogReviewForm:{
        status:0
      },
      statusOptions: [
        {
          statusCode:0,
          statusName:"未审核"
        },
        {
          statusCode:1,
          statusName:"审核中"
        },
        {
          statusCode:2,
          statusName:"审核通过"
        },
        {
          statusCode:3,
          statusName:"审核未通过"
        }
      ],
      tableHeight: 850,
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  mounted() {
    //this.tableHeight = document.body.clientHeight - 220;
    getAllShopType().then(res=>{
      if (res.success){
        this.allShopTypes = res.data;
      }
    });
    //console.log(this.$route.query.reviewstatus)
    if (!isStrEmpty(this.$route.query.reviewstatus)){
      this.queryForm.status = this.$route.query.reviewstatus
      console.log(this.queryForm.status)
    }
    this.getData();
  },
  methods: {
    handleShopEdit(index, row,dialogTitle) {
      this.dialogFormVisible = true;
      this.dialogTitle = dialogTitle
      this.resetDialogForm()
      this.dialogForm = {...row}
      getShopSetting(this.dialogForm).then(res=>{
        if (res.success){
          this.dialogForm = res.data;
          console.log(this.dialogForm)
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    submitDialogForm(){
      this.dialogForm.shopNameShowPositionAry = this.shopNameShowPositionAry;
      this.$refs[this.dialogRefName].validate((valid) => {
        if (valid) {
          this.$confirm("确定提交数据么?")
              .then(_ => {
                updateShopSetting(this.dialogForm).then(res=>{
                  if (res.success){
                    this.getData();
                    this.$message.success("更新状态成功！")
                    this.dialogFormVisible = false;
                  }
                }).catch(err => {
                  this.$message({message: err.message, type: 'error'});
                });
                //取消新增或修改也要重置表单
              }).catch(err => {this.handleCloseDialog();});
        } else {
          return false;
        }
      });
    },
    reviewBatchPass(){
      console.log(this.multipleSelection)
      this.$confirm("确定通过审核勾选店铺信息?").then(_ =>{
        updateBatchShopStatus(this.multipleSelection).then(res => {
          if (res.success){
            this.getData();
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
        });
      });
    },
    submitStatus(status){
      this.$refs[this.dialogReviewRefName].validate((valid) => {
        if (valid) {
          //this.$confirm("确定提交数据么?")
          //    .then(_ => {
                updateShopStatus({shopId:this.dialogReviewForm.id, status:status, because:this.dialogReviewForm.because}).then(res=>{
                  if (res.success){
                    this.getData();
                    this.$message.success("更新状态成功！")
                    this.dialogReviewFormVisible = false;
                  }
                }).catch(err => {
                  this.$message({message: err.message, type: 'error'});
                });
                //取消新增或修改也要重置表单
              //}).catch(err => {this.handleReviewCloseDialog();});
        } else {
          return false;
        }
      });
    },
    resetDialogReviewForm(){
      for(let item in this.dialogReviewForm){
        if (typeof this.dialogReviewForm[item]==='string'){
          this.dialogReviewForm[item]='';
        } else if (this.dialogReviewForm[item] instanceof Array) {
          this.dialogReviewForm[item]=[];
        } else{
          this.dialogReviewForm[item]=null
        }
      }
    },
    handleReviewEdit(index, data, title){
      this.dialogReviewFormVisible = true;
      this.dialogReviewTitle = title;
      this.resetDialogReviewForm()
      this.dialogReviewForm = {...data}
    },
    handleReviewCloseDialog(){
      this.$refs[this.dialogReviewRefName].resetFields();
      this.dialogReviewFormVisible = false;
    },
    getData(){
      getShopsVo(this.queryForm, this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
    getStrEndWithNumbers(numbers) {
      return getStrEndWithNumbers(numbers, 8);
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
